import React from 'react';
import { ClockIcon, MoveUpIcon, ScanLineIcon, SparklesIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { benefits, treatmentAreas } from '../data/content';
import type { BenefitIcon } from '../types/landing';
import { useConsult } from '../contexts/ConsultContext';
const DEVICE_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/3677d5b9-4d5e-4265-8f95-04f4d4427d4e.jpg';
const icons: Record<BenefitIcon, React.ComponentType<{
  className?: string;
}>> = {
  lift: MoveUpIcon,
  scan: ScanLineIcon,
  collagen: SparklesIcon,
  clock: ClockIcon
};
export function WhyItWorks() {
  const {
    openConsult
  } = useConsult();
  return <section id="why" className="w-full bg-white py-20 lg:py-28" data-id="element-221" data-mp="3btuzn35voqkf">
      <div className="mx-auto w-full max-w-7xl px-5 lg:px-8" data-id="element-222" data-mp="3gp1y9wkaj52h">
        <div className="grid gap-14 lg:grid-cols-[0.9fr_1.1fr] lg:items-start lg:gap-20" data-id="element-223" data-mp="20btwa32ilp8o">
          <div className="lg:sticky lg:top-28" data-id="element-224" data-mp="25b6luvkrtaey">
            <h2 className="font-display text-4xl leading-tight tracking-tight text-ash-900 lg:text-5xl" data-id="element-225" data-mp="25d1585ge8ugx">
              Why it reaches what creams never will
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-ash-600" data-id="element-226" data-mp="3pb5gqcjdyb8n">
              Micro-focused ultrasound passes harmlessly through the surface and deposits energy at precise depths
              beneath it — including the same tissue layer addressed in surgical lifts.
            </p>
            <img src={DEVICE_IMAGE} alt="Ultrasound aesthetic treatment device with live imaging display" className="mt-8 aspect-[4/3] w-full rounded-2xl object-cover" data-id="element-227" data-mp="h1vgrq4t6qfz" />
            <Button className="mt-8" size="lg" onClick={() => openConsult('why-section')} data-id="element-228" data-mp="qr5atbj7qj6q">
              See if you&apos;re a candidate
            </Button>
          </div>

          <div data-id="element-229" data-mp="zsd6dluch5x4">
            <dl className="grid gap-x-10 gap-y-10 sm:grid-cols-2" data-id="element-230" data-mp="zu6buxt81k3j">
              {benefits.map(benefit => {
              const Icon = icons[benefit.icon];
              return <div key={benefit.title} className="flex flex-col" data-id="element-231" data-mp="12vj2k3s5y6nv">
                    <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-royal-50 text-royal-600" data-id="element-232" data-mp="17tku7d3nneay">
                      <Icon className="h-5 w-5" aria-hidden="true" data-id="element-233" data-mp="1csnnk0a9vw33" />
                    </span>
                    <dt className="mt-4 text-lg font-semibold tracking-tight text-ash-900" data-id="element-234" data-mp="1hk5mkisqjmlf">{benefit.title}</dt>
                    <dd className="mt-2 text-[15px] leading-relaxed text-ash-600" data-id="element-235" data-mp="1lk7gu6w55dqo">{benefit.body}</dd>
                  </div>;
            })}
            </dl>

            <div className="mt-14 border-t border-ash-200 pt-10" data-id="element-236" data-mp="1vjomiobe7rmn">
              <h3 className="text-sm font-bold uppercase tracking-[0.18em] text-ash-500" data-id="element-237" data-mp="1vhc4yc9jrja4">Where it&apos;s treated</h3>
              <ul className="mt-6 divide-y divide-ash-200" data-id="element-238" data-mp="15dvqab8mne8">
                {treatmentAreas.map(area => <li key={area.name} className="flex items-baseline justify-between gap-6 py-3.5" data-id="element-239" data-mp="647a04ycmifg">
                    <span className="text-base font-semibold text-ash-900" data-id="element-240" data-mp="2jei8rfm48fdo">{area.name}</span>
                    <span className="text-right text-sm text-ash-500" data-id="element-241" data-mp="2eo1r1jb9i7li">{area.note}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}